import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    tagsPositioner: {
      width: 275,
    },
    labelMore: {
      height: 24,
      ...theme.typography.regular14,
      padding: theme.spacing(0, 0.75),
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    chip: {
      maxWidth: 200,
    },
  }),
  { name: 'ImageOverlayTextValue' }
);
